import React from 'react'

import { Empty } from 'src/components/Ant'
import { FormikProps, FormikValues } from 'formik'
import { Form, Row, Col } from 'antd'

function defaultRenderForm(formikProps: FormikProps<FormikValues>) {
  return (
    <Form onSubmit={formikProps.handleSubmit}>
      <Row>
        <Col span={22}>
          <Empty description="web.reports.modal.no-params" />
        </Col>
      </Row>
    </Form>
  )
}

function ReportNotFound() {
  return <Empty description="web.report.report-not-found" />
}

export default ReportNotFound
export { defaultRenderForm }
